/**
 * The team's clock: days, weeks and business hours are New York's (`America/New_York`), applied
 * where a day is computed and never on the wire (instants stay UTC).
 */
export const BUSINESS_TIME_ZONE = 'America/New_York';
const WEEKDAY_FROM_MONDAY = {
    Mon: 0,
    Tue: 1,
    Wed: 2,
    Thu: 3,
    Fri: 4,
    Sat: 5,
    Sun: 6,
};
const zoneParts = new Intl.DateTimeFormat('en-US', {
    timeZone: BUSINESS_TIME_ZONE,
    hourCycle: 'h23',
    weekday: 'short',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
});
/** `at` on the New York clock: its weekday (Monday = 0) and its wall time as if it were UTC. */
export function wallClock(at) {
    const parts = Object.fromEntries(zoneParts.formatToParts(at).map((p) => [p.type, p.value]));
    return {
        weekday: WEEKDAY_FROM_MONDAY[parts.weekday],
        asUtc: Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second)),
    };
}
/**
 * The instant a New York wall-clock time (given as if it were UTC) happens, DST included. A time
 * the spring-forward gap skips takes the first instant after the gap.
 */
export function zonedToInstant(wallAsUtc) {
    const wallAt = (instant) => wallClock(new Date(instant)).asUtc;
    const offsetAt = (instant) => wallAt(instant) - Math.floor(instant / 1000) * 1000;
    const guess = wallAsUtc - offsetAt(wallAsUtc);
    const instant = wallAsUtc - offsetAt(guess);
    if (wallAt(instant) === Math.floor(wallAsUtc / 1000) * 1000)
        return instant;
    // In the gap: the two offsets bracket the jump; find its minute.
    const other = wallAsUtc - offsetAt(instant);
    let lo = Math.min(instant, other);
    let hi = Math.max(instant, other);
    while (hi - lo > 60_000) {
        const mid = lo + Math.floor((hi - lo) / 120_000) * 60_000;
        if (wallAt(mid) >= wallAsUtc)
            hi = mid;
        else
            lo = mid;
    }
    return hi;
}
//# sourceMappingURL=business-time.js.map